import { useState } from "react";
import { Modal, Number } from "../UI";
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import { mq } from "../responsive";

const People = ({ people, onChange, style }) => {
  const [visible, setVisible] = useState(false);
  const [adults, setAdult] = useState(people[0]);
  const [children, setChildren] = useState(people[1]);

  const handlePeopleChange = (e) => {
    e.stopPropagation();
    onChange([adults, children]);
    setVisible(false);
  };

  return (
    <div
      css={{ userSelect: "none", ...style }}
      onClick={() => setVisible(true)}
    >
      <Modal
        trigger={
          <span
            css={{
              whiteSpace: "nowrap",
              [mq.md]: { fontWeight: 500 },
              padding: "0 1rem",
              [mq.lg]: {
                padding: "0 3rem",
              },
            }}
          >{`${adults} ${adults > 1 ? "adults" : "adult"}${
            children > 0
              ? `, ${children} ${children > 1 ? "children" : "child"}`
              : ""
          }`}</span>
        }
      >
        <Number
          label="Adult"
          min={1}
          max={5}
          onChange={(value) => setAdult(value)}
        />
        <Number
          label="Children"
          min={0}
          max={2}
          onChange={(value) => setChildren(value)}
        />
      </Modal>
    </div>
  );
};

export default People;
